import api from '@pray/shared/utils/api';

import { buildDailyItemLocalesUrl } from './buildDailyItemLocalesUrl';
import type { DailyItemLocaleRef, SaveDailyItemLocaleParams } from './types';

/** Upserts the daily item's text translation for one locale (204). */
export async function saveDailyItemLocale(
  ref: DailyItemLocaleRef,
  localeCode: string,
  params: SaveDailyItemLocaleParams
) {
  const url = `${buildDailyItemLocalesUrl(ref)}/${localeCode}`;

  const body = {
    body: params.body,
    quote: params.quote ?? null,
    reference: params.reference ?? null,
  };

  await api.executePutRequest(url, body);

  return { success: true };
}
